import { useEffect } from 'react';
export const useOnLoadsEvents = ({ onReady, image }) => {
    useEffect(() => {
        if (onReady && !image) {
            onReady();
        }
    }, [onReady, image]);
    return {
        onImageLoad: (e) => {
            if (image === null || image === void 0 ? void 0 : image.onLoad) {
                image.onLoad(e);
            }
            if (onReady) {
                onReady();
            }
        },
    };
};
//# sourceMappingURL=useOnLoadsEvents.js.map